module.exports = __webpack_public_path__ + "img/ongfacil.44e84721.png";